var useState_book_instance, useState_book_loading, useState_toc;

import create_external_state from 'state_mini';

import Epub from 'epubjs';

// Epub 实例
useState_book_instance = create_external_state();

export var useValue_book_instance = function() {
  return useState_book_instance().value;
};

export var get_book_instance = function() {
  return useState_book_instance.get();
};

// loading
useState_book_loading = create_external_state();

export var useValue_book_loading = function() {
  return useState_book_loading().value;
};

// 书的目录
useState_toc = create_external_state();

useState_book_instance.subscribe(async function(book) {
  var navigation;
  useState_toc.set2(null);
  navigation = (await book.loaded.navigation);
  return useState_toc.set2(navigation.toc);
});

export var useValue_toc = function() {
  return useState_toc().value;
};

// 设置 Epub 实例
export var make_book = async function(source) {
  var book;
  if (source) {
    book = Epub();
    useState_book_loading.set2(true);
    await book.open(source); // http://epubjs.org/documentation/0.3/#bookopen
    useState_book_loading.set2(false);
    return useState_book_instance.set2(book);
  } else {
    useState_book_instance.set2(null);
    return useState_toc.set2(null);
  }
};
